<template>
  <div class="home">
    <div class="row">
      <div class="col-12">
        <router-link class="btn btn-primary" to="/Configuration" tag="button">Konfiguration</router-link>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <button class="btn btn-primary" @click="onStartScan">
          Scannen
        </button>
        <br><br>
      </div>
    </div>
    <div class="row justify-content-center" v-if="state.onScan">
      <div class="col-6">
        <span class="pageCnt">Anzahl Seiten {{state.pages}}</span>

        <b-progress :value="state.value"
                    show-progress
                    :variant="state.variant"
                    :key="state.variant"
        >
        </b-progress>

        {{messageCode}}: {{message}}

        <br><br>
        <mySortableDash :notClickable="false" ref="sortDash" :data="pageArray" :config="dashConfig"
                        :host="wbHost"></mySortableDash>

        <button @click="downloadAsPDF()">download PDF</button>
        <button @click="downloadAsTIFF()">download TIFF</button>
      </div>

    </div>
  </div>
</template>

<script>
import mySortableDash from './list/vue-sortable-dash.vue'
import Vue from 'vue'
import sas from 'surfandscan'
export default {
  name: 'Home',
  components: {
    mySortableDash
  },
  data () {
    return {
      wbHost: 'xxx',
      messageCode: '',
      message: '',
      state: {
        onScan: false,
        value: 1,
        pages: 0,
        variant: 'success'
      },
      pageArray: [],
      scanParameter: {
        duplex: false,
        feederUnit: -1
      },
      dashConfig: {
        hasURLMaker: true,
        dashClass: 'marken',
        hasImage: true,
        hasText: true,
        link: '/PrintMedia/'
      }
    }
  },
  mounted () {
  },
  methods: {
    onScanComplete (data) {
      console.log('onScanComplete', data)
    },
    checkStatus () {
      console.log('check status', this.currentScanJob)
      sas.getTaskStatus(this.currentScanJob.id, this.onScanSuccess)
    },
    downloadAsPDF () {
      sas.downloadTaskAsPDF(this.currentScanJob.id)
    },
    downloadAsTIFF () {
      sas.downloadTaskAsTIFF(this.currentScanJob.id)
    },
    onScanSuccess (data) {
      console.log('onScanSuccess', data)
      this.state.onScan = true
      if (data) {
        this.currentScanJob = data
      }
      this.state.value = this.currentScanJob.progress
      this.state.pages = this.currentScanJob.pageNo
      this.pageArray = this.currentScanJob.files
      this.messageCode = ''
      if (this.currentScanJob.message) {
        this.messageCode = this.currentScanJob.messageCode
      }

      this.message = this.currentScanJob.message

      for (let i = 0; i < this.pageArray.length; i++) {
        this.pageArray[i].imageUrl = Vue.prototype.$dms.getThumbnailUrl(this.pageArray[i].id)
      }
      if (this.currentScanJob.status !== 'done') {
        window.setTimeout(this.checkStatus, 800)
      } else {
        this.onScanComplete(this.currentScanJob)
      }
    },
    onError (error, var1, var2) {
      console.log('onError', error, var1, var2)
      this.state.onScan = false
    },
    onStartScan () {
      Vue.prototype.$scanApi(this.scanParameter, this.onScanSuccess, this.onError)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue